import React from "react";
import { Image, Row, Col } from "antd";
import logo from "../../assets/images/my-friend-logo-blue.svg";
import { componentStyles } from "./UserHeaderStyles";

const SignUpUserHeader = ({ setDrawer, isConversationStarted }) => {

  const sectionsContainerStyle = {
    transition: "opacity 0.3s ease, pointer-events 0.3s ease"
  };  

  return (
    <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
      <Row
        justify={{
          xs: "space-around",
          md: "space-around",
          lg: "space-between",
        }}
          style={{ marginBottom: 10 }}
            >
        <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
          <Row justify="space-between" align="middle" style={componentStyles.padding}>
            <Col xs={14} md={12}>
              <Image
              src={logo}
              alt="my-friend-logo"
              preview={false}
              style={componentStyles.logo}
              />
            </Col>
          </Row>
        </Col>
      </Row> 
    </Col>
  );
};

export default SignUpUserHeader;